import {
  Grid,
  TextField,
  InputLabel,
  FormHelperText,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";

const TextArea = (props) => {
  const { label, name, formik, placeholder, required, ...rest } = props;
  return (
    <Grid>
      <Box
        sx={{
          borderLeft: formik.errors[name] ? "4px solid #ca2e2e" : "",
          paddingLeft: formik.errors[name] ? "16px" : "",
        }}
      >
        <InputLabel
          htmlFor={name}
          sx={{
            textAlign: "left",
            textStyle: "none",
          }}
        >
          <Typography
            mb={2}
            variant="h3"
            sx={{
              fontWeight: required ? "bold" : "500",
            }}
          >
            {label}
          </Typography>
        </InputLabel>
        <TextField
          fullWidth
          multiline
          placeholder={placeholder}
          minRows={5}
          id={name}
          {...formik.getFieldProps(`${name}`)}
          {...rest}
        />
        <FormHelperText error>
          <Typography
            variant="body1"
            sx={{
              marginTop: "16px",
              fontWeight: "bolder",
            }}
          >
            {formik.errors[name]}
          </Typography>
        </FormHelperText>
      </Box>
    </Grid>
  );
};

export default TextArea;
